import { ILinkedPageObjectSpecifiable } from "../../../../../../../documaker/domain/format/objects";
import { ObjectTargetsTranslator } from "./ObjectTargetsTranslator";
import { LinkedPageObjectTranslator } from "./LinkedPageObjectTranslator";

export class ItemSelectTriggerBehaviorTranslator extends ObjectTargetsTranslator<ILinkedPageObjectSpecifiable> {
  constructor() {
    super("user-define", new LinkedPageObjectTranslator());
  }
}
